export const LIMIT_POSITION = 99;
